module.exports = __webpack_public_path__ + "img/top-list-left1.42aec2d3.png";